import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './FootPrintApiManager.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_find_and_cancel_ordersService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { project_lookup_code?: string, order_class?: string, order_type_id?: number, order_lookup_code?: string, owner_reference?: string, vendor_reference?: string, order_id?: number, order_notes?: string, order_age_days?: number }): Promise<{ success?: boolean, messages?: any[], order_ids?: number[], shipment_ids?: number[], error?: string }> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/functions/find_and_cancel_orders`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

